import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@shared/services/auth.service';

/**
 * Club-app guest guard.
 *
 * Any authenticated user — staff/superuser or regular — has no business on the
 * guest auth pages (login/register/forgot/reset) and is sent to /events. This
 * deliberately does NOT special-case staff: in the club app a staff/superuser
 * is treated exactly like a regular participant.
 *
 * The shared `guestGuard` bounces authenticated staff to /staff/dashboard,
 * which is correct for the staff app but wrong here — /staff/dashboard lives in
 * the separate staff SPA on another host, so an in-app navigation can never
 * reach it. Using a club-local guard keeps the shared one intact for staff. (#473)
 */
export const clubGuestGuard = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return true;
  }
  return router.createUrlTree(['/events']);
};
